const roleToTitleCase = (role: string) =>
  role
    .replace(/_/g, ' ')
    .split(' ')
    .map((word) => `${word[0].toUpperCase()}${word.substring(1)}`)
    .join(' ');

export {roleToTitleCase};
